<template>
  <div class="app account-container">
    <div class="header-fixed">
      <AccountHeader/>
      <main class="main">
        <div class="app-body">
          <router-view :key="$route.fullPath"/>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import AccountHeader from '../components/Header/AccountHeader';

export default {
  components: {
    AccountHeader,
  },
};
</script>
